import { themeI18n } from '../utils/i18n_helper';
import { formatMoney } from '@shopify/theme-currency';

export const Price = ({ product, selectedVariant }) => {
  const priceItem = selectedVariant ?? product;
  const onSale = priceItem.compare_at_price ? priceItem.compare_at_price > priceItem.price : false;

  return (
    <div className={`price ${onSale && 'price--on-sale'}`}>
      <dl>
        <div className="price__regular">
          <dt>
            <span className="visually-hidden visually-hidden--inline">
              {themeI18n('products.price.regular_price')}
            </span>
          </dt>
          <dd className="price__last">
            <span className="price-item price-item--regular">
              {(product.price_varies && !selectedVariant) &&
                <span className="price__varies text-small">
                  {themeI18n('products.price.from_price_html')}
                </span>
              }
              <span> </span>
              {formatMoney(priceItem.price).replace('.00', '')}
            </span>
          </dd>
        </div>

        {onSale && (
          <div className="price__sale">
            <dt className="visually-hidden">
              <span className="visually-hidden visually-hidden--inline">
                {themeI18n('products.price.sale_price')}
              </span>
            </dt>
            <dd className="price__last">
              <span className="price-item price-item--sale">
                {(product.price_varies && !selectedVariant) &&
                  <span className="price__varies text-small">
                    {themeI18n('products.price.from_price_html')}
                  </span>
                }
                <span> </span>
                {formatMoney(priceItem.price).replace('.00', '')}
              </span>
            </dd>
            <dt className="price__compare visually-hidden">
              <span className="visually-hidden visually-hidden--inline">
                {themeI18n('products.price.regular_price')}
              </span>
            </dt>
            <dd className="price__compare">
              <s className="price-item price-item--regular">
                {formatMoney(priceItem.compare_at_price).replace('.00', '')}
              </s>
            </dd>
          </div>
        )}
      </dl>
    </div>
  );
};
